import { render, staticRenderFns } from "./CvSocialLinks.vue?vue&type=template&id=9ae5a6ee&scoped=true"
import script from "./CvSocialLinks.vue?vue&type=script&lang=js"
export * from "./CvSocialLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae5a6ee",
  null
  
)

export default component.exports